<div class="container">
  <!-- <nh-alert type="danger" [isOpen]="isAlertMessage" dismissible="true">{{ alertMessage | globalTranslate }}</nh-alert> -->

  <nh-alert type="danger" [isOpen]="showErr2">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span>{{ "PASSWORD_GUIDELINES" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>

  <nh-alert type="danger" [isOpen]="isAlertMsg()">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span>{{ alertMessage | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>

  <div class="bg-custom-register">
    <h1 class="section-header">{{ "CHANGE_PASSWORD" | globalTranslate }}</h1>
    <hr />

    <section>
      <div class="col-md-12">
        <p [innerHtml]="'CHANGE_PASSWORD_TEXT' | globalTranslate"></p>
        <h2 class="section-header">{{ "SET_NEW_PWD" | globalTranslate }}</h2>
        <hr />
        <p [innerHtml]="'PASSWORD_GUIDELINES_TITLE' | globalTranslate"></p>
        <form [formGroup]="changePassword">
          <div class="row">
            <div class="col-12 col-md-6">
              <nh-field
                [isRow]="true"
                label="{{ 'CURRENT_PWD' | globalTranslate }}"
                class="label-section"
              >
                <div class="password-eye">
                  <input
                    [type]="fieldCurrentTextType ? 'text' : 'password'"
                    class="form-control"
                    formControlName="currentPassword"
                    placeholder="{{ 'CURRENT_PWD' | globalTranslate }}"
                    required
                  />
                  <button
                    type="button"
                    class="eye-icon"
                    tabindex="0"
                    (click)="toggleFieldTextType('currentPassword')"
                    (keydown.enter)="toggleFieldTextType('currentPassword')"
                    (keydown.space)="
                      $event.preventDefault();
                      toggleFieldTextType('currentPassword')
                    "
                    [attr.aria-label]="
                      fieldTextType
                        ? ('HIDE_PASSWORD' | globalTranslate)
                        : ('SHOW_PASSWORD' | globalTranslate)
                    "
                    [attr.aria-pressed]="fieldTextType"
                  >
                    <img
                      alt=""
                      aria-hidden="true"
                      src="assets/images/Icons/eye-outline-password.svg"
                    />
                  </button>
                </div>
              </nh-field>
              <nh-field
                [isRow]="true"
                label="{{ 'SET_NEW_PWD' | globalTranslate }}"
                class="label-section"
              >
                <div class="password-eye">
                  <input
                    [type]="fieldTextType ? 'text' : 'password'"
                    class="form-control"
                    formControlName="password"
                    placeholder="{{ 'ENTER_PASSWORD' | globalTranslate }}"
                    (keyup)="validatePassword($event)"
                    required
                  />
                  <button
                    type="button"
                    class="eye-icon"
                    tabindex="0"
                    (click)="toggleFieldTextType('password')"
                    (keydown.enter)="toggleFieldTextType('password')"
                    (keydown.space)="
                      $event.preventDefault(); toggleFieldTextType('password')
                    "
                    [attr.aria-label]="
                      fieldTextType
                        ? ('HIDE_PASSWORD' | globalTranslate)
                        : ('SHOW_PASSWORD' | globalTranslate)
                    "
                    [attr.aria-pressed]="fieldTextType"
                  >
                    <img
                      alt=""
                      aria-hidden="true"
                      src="assets/images/Icons/eye-outline-password.svg"
                    />
                  </button>
                </div>
              </nh-field>
              <nh-field
                [isRow]="true"
                label="{{ 'CONFIRM_PASSWORD' | globalTranslate }}"
                class="label-section"
              >
                <div class="password-eye">
                  <input
                    [type]="fieldConfirmPassTextType ? 'text' : 'password'"
                    class="form-control"
                    formControlName="confirmPassword"
                    placeholder="{{ 'CONFIRM_PASSWORD' | globalTranslate }}"
                    (keyup)="comparePassword($event)"
                    (change)="getErrorMessage()"
                    required
                  />
                  <button
                    type="button"
                    class="eye-icon"
                    tabindex="0"
                    (click)="toggleFieldTextType('confirmPassword')"
                    (keydown.enter)="toggleFieldTextType('confirmPassword')"
                    (keydown.space)="
                      $event.preventDefault();
                      toggleFieldTextType('confirmPassword')
                    "
                    [attr.aria-label]="
                      fieldConfirmPassTextType
                        ? ('HIDE_PASSWORD' | globalTranslate)
                        : ('SHOW_PASSWORD' | globalTranslate)
                    "
                    [attr.aria-pressed]="fieldConfirmPassTextType"
                  >
                    <img
                      alt=""
                      aria-hidden="true"
                      src="assets/images/Icons/eye-outline-password.svg"
                    />
                  </button>
                </div>
              </nh-field>
            </div>
            <div class="col-12 col-md-6">
              <div class="password-guide">
                <div class="password-header">
                  <span>{{ "PWD_GUIDE" | globalTranslate }}</span>
                  <hr />
                </div>
                <ul>
                  @if (passwordRuleLen) {
                  <li class="password-rules-valid">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/met icon_PWGuidelines.svg"
                        alt=""
                      />
                      <div>
                        <span class="visually-hidden">{{
                          "PASSWORD_REQ_MET" | globalTranslate
                        }}</span>
                        {{ "PG_1" | globalTranslate }}
                      </div>
                    </div>
                  </li>
                  } @if (!passwordRuleLen) {
                  <li class="password-rules">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/not met icon_PWGuidelines.svg"
                        alt=""
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                          {{ "PG_1_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_1" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (passwordRuleUpp) {
                  <li class="password-rules-valid">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/met icon_PWGuidelines.svg"
                        alt=""
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                          {{ "PG_2_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_2" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (!passwordRuleUpp) {
                  <li class="password-rules">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/not met icon_PWGuidelines.svg"
                        alt=""
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                          {{ "PG_2_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_2" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (passwordRuleLow) {
                  <li class="password-rules-valid">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/met icon_PWGuidelines.svg"
                        alt=""
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                          {{ "PG_3_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_3" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (!passwordRuleLow) {
                  <li class="password-rules">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/not met icon_PWGuidelines.svg"
                        alt=""
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                          {{ "PG_3_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_3" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (passwordRuleNum) {
                  <li class="password-rules-valid">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/met icon_PWGuidelines.svg"
                        alt=""
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                          {{ "PG_4_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_4" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (!passwordRuleNum) {
                  <li class="password-rules">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/not met icon_PWGuidelines.svg"
                        alt=""
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                          {{ "PG_4_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_4" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (passwordRuleSpl) {
                  <li class="password-rules-valid">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/met icon_PWGuidelines.svg"
                        alt=""
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                          {{ "PG_5_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_5" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (!passwordRuleSpl) {
                  <li class="password-rules">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/not met icon_PWGuidelines.svg"
                        alt=""
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                          {{ "PG_5_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_5" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </form>
      </div>
      <br />
      <br />
    </section>
  </div>
</div>